import axios from 'axios'
import store from '../store'
export const AmountUtils = {
  methods: {
    async getAmount (confirmationNumber) {
      await axios.post(process.env.SERVER_URI + '/get_amount', {'confirmation_number': confirmationNumber}).then((response) => {
        if (response.data === false) {
          store.state.amount = ''
        } else {
          store.state.amount = response.data
        }
      }).catch(() => {
        store.state.amount = ''
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/Amount.js